export default __webpack_public_path__ + "static/media/logothvertical.0b3ecc5a.png";